import {defineType} from 'sanity'

export default defineType({
  name: 'linkCta',
  type: 'object',
  title: 'Link CTA',
  fields: [
    {
      name: 'label',
      type: 'string',
    },
    {
      name: 'url',
      type: 'url',
      description: '',
      validation: (Rule) => Rule.required(),
    },
    {
      name: 'buttonType',
      type: 'buttonType',
    },
    {
      title: 'Open in new tab',
      name: 'openInNewTab',
      type: 'boolean',
    },
  ],
  preview: {
    select: {
      title: 'label',
    },
    prepare({title}) {
      return {
        title: title || 'Discover more',
      }
    },
  },
})
